import { AxiosError } from 'axios';

import { selectOrganisationInfos } from '@/domain/organisation/organisation.selectors';
import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getProjectsVenue } from './get-projects-venue.action';

type Params = {
  project: ProjectVenue;
};

export const createProjectVenue = createAppAsyncThunk(
  'projectVenue/createProjectVenue',
  async (
    params: Params,
    { extra: { projectVenueGateway, snackbarGateway }, dispatch, getState },
  ): Promise<void> => {
    const organisationInfos = selectOrganisationInfos(getState());
    try {
      params.project.organisationId = organisationInfos.id;
      await projectVenueGateway.create(params.project);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getProjectsVenue());
    } catch (error) {
      let errorMessageKey = translate('CreateProject.Message.error');
      if (error instanceof AxiosError && error.status === 402) {
        errorMessageKey = translate('CreateProject.Message.limited');
      }
      showSnackbarError(snackbarGateway, errorMessageKey);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('CreateProject.Message.success'));
}

function showSnackbarError(
  snackbarGateway: SnackbarGateway,
  errorMessage: string,
) {
  snackbarGateway.error(errorMessage);
}
